import { analytics } from "@flare/analytics";

import { getAnonymousId } from "@/utils/anonymous-id";
import { isE2ETest } from "@/utils/e2e/isE2ETest";

import { indentifyUser } from "./plugins";

export function initializeAnalytics() {
  analytics.init({
    writeKey: process.env.NEXT_PUBLIC_SEGMENT_ID as string,
    disable: process.env.NODE_ENV === "development" || isE2ETest(),
    anonymousId: getAnonymousId(),
  });

  analytics.registerPlugin(indentifyUser);
}
